<script>
import { Icon, latLngBounds } from 'leaflet';
import { LMap, LTileLayer, LMarker, LPopup } from 'vue2-leaflet';

delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

export default {
  name: 'PopMapModal',
  components: { LMap, LTileLayer, LMarker, LPopup },
  props: {
    open: { type: Number, default: 0 },
  },
  data() {
    return {
      loading: false,
      items: [],
      zoom: 10,
      center: [35.1856, 33.3823],
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
    };
  },
  computed: {
    markers() {
      const list = [];
      (this.items || []).forEach((item) => {
        const latlng = this.parseCoordinate(item.coordinate);
        if (!latlng) return;
        list.push({
          id: item.id,
          name: item.name,
          address: item.address,
          explaine: item.explaine,
          coordinate: item.coordinate,
          latlng,
        });
      });
      return list;
    },
  },
  watch: {
    open() {
      this.$bvModal.show('pop_all_map_modal');
      this.loadItems();
    },
  },
  methods: {
    parseCoordinate(raw) {
      if (!raw) return null;
      const parts = String(raw).split(',').map(v => parseFloat(String(v).trim()));
      if (parts.length !== 2 || parts.some(v => Number.isNaN(v))) return null;
      return parts;
    },
    async loadItems() {
      this.loading = true;
      try {
        const response = await this.$http.post('/transmitter/groups?map=true');
        this.items = Array.isArray(response.data) ? response.data : [];
        this.$nextTick(() => {
          setTimeout(() => this.fitBounds(), 250);
        });
      } finally {
        this.loading = false;
      }
    },
    fitBounds() {
      const map = this.$refs.map && this.$refs.map.mapObject;
      if (!map) return;
      map.invalidateSize();
      if (!this.markers.length) {
        map.setView(this.center, this.zoom);
        return;
      }
      if (this.markers.length === 1) {
        map.setView(this.markers[0].latlng, 14);
        return;
      }
      const bounds = latLngBounds(this.markers.map(m => m.latlng));
      map.fitBounds(bounds, { padding: [40, 40], maxZoom: 14 });
    },
    onShown() {
      this.$nextTick(() => this.fitBounds());
    },
    close() {
      this.$bvModal.hide('pop_all_map_modal');
    },
    openEdit(marker) {
      this.close();
      this.$emit('edit', marker);
    },
  },
};
</script>

<template>
  <b-modal
    id="pop_all_map_modal"
    title="POP Noktaları Haritası"
    size="xl"
    no-close-on-backdrop
    hide-footer
    @shown="onShown"
  >
    <div class="d-flex justify-content-between align-items-center mb-2">
      <span>
        Haritada
        <strong>{{ markers.length }}</strong>
        POP noktası
        <span class="text-muted" v-if="loading"> · yükleniyor...</span>
      </span>
      <button class="btn btn-secondary btn-sm" type="button" @click="close">Kapat</button>
    </div>

    <div v-if="!loading && !markers.length" class="alert alert-warning mb-0">
      Koordinatlı POP noktası bulunamadı.
    </div>

    <l-map
      v-else
      ref="map"
      :zoom="zoom"
      :center="center"
      style="height: 70vh; width: 100%; z-index: 1; border-radius: 10px;"
    >
      <l-tile-layer :url="url" />
      <l-marker
        v-for="marker in markers"
        :key="marker.id"
        :lat-lng="marker.latlng"
      >
        <l-popup>
          <strong>{{ marker.name }}</strong><br>
          <span v-if="marker.address">{{ marker.address }}<br></span>
          <small class="text-muted">{{ marker.coordinate }}</small>
          <div class="mt-2">
            <button class="btn btn-sm btn-primary" type="button" @click="openEdit(marker)">
              Konumu Güncelle
            </button>
          </div>
        </l-popup>
      </l-marker>
    </l-map>
  </b-modal>
</template>
